import { Alert, Typography, Box, Grid } from '@mui/material';
import { StyledLink, Paragraph } from 'components/layouts/SharedStyles';
import { mailtoLink } from 'utils/misc';
import { config } from 'config';

export const IntroHeader = () => {
  return (
    <>
      <Typography variant='h6' component='h1' gutterBottom>
        {config.event.title} Admissions
      </Typography>

      <Box sx={{ my: 2, border: '1px solid', borderColor: 'divider', p: 2, borderRadius: 1, backgroundColor: 'background.paper' }}>
        <Grid container spacing={1}>
          <Grid item xs={2}><Typography variant='body1'>Date:</Typography></Grid>
          <Grid item xs={10}><Typography variant='body1'>Saturday, March 14, 2026</Typography></Grid>
          
          <Grid item xs={2}><Typography variant='body1'>Cost:</Typography></Grid>
          <Grid item xs={10}><Typography variant='body1'>$25 suggested, sliding scale from $15 - $40 per person</Typography></Grid>
          
          <Grid item xs={2}><Typography variant='body1'>Time:</Typography></Grid>
          <Grid item xs={10}>
            <Typography variant='body1'>
              6:45 PM Newcomers teaching session<br />
              7:15 PM - 10:30 PM Dancing
            </Typography>
          </Grid>
          
          <Grid item xs={2}><Typography variant='body1'>Place:</Typography></Grid>
          <Grid item xs={10}><Typography variant='body1'>Smith Memorial Student Union Ballroom, Portland State University, 1825 SW Broadway, Portland, OR 97201</Typography></Grid>
          
          <Grid item xs={2}><Typography variant='body1'>Caller:</Typography></Grid>
          <Grid item xs={10}><Typography variant='body1'>Lindsey Dono</Typography></Grid>
          
          <Grid item xs={2}><Typography variant='body1'>Music:</Typography></Grid>
          <Grid item xs={10}><Typography variant='body1'>The Portland Megaband - 75 musicians playing precision and enthusiasm</Typography></Grid>
        </Grid>
      </Box>

      <Paragraph>
        Your name will be on a list at the door. No physical tickets will be issued.
      </Paragraph>

      <Paragraph>Paying by check? <StyledLink internal={true} to="/check">Click here</StyledLink>.</Paragraph>

      <Paragraph>
        Registration system questions? Email <StyledLink to={mailtoLink(config.contacts.tech)}>{config.contacts.tech}</StyledLink>.<br />
        Any other questions? Email <StyledLink to={mailtoLink(config.contacts.info)}>{config.contacts.info}</StyledLink>.
      </Paragraph>

      <Alert severity='info' sx={{ my: 3 }}>
        <Typography variant='body1'>After hitting save, there will be an opportunity to add additional attendees.</Typography>
      </Alert>

      {config.registration.showWaiver && (
        <Alert severity='warning' sx={{ my: 2 }}>
          <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
            Important note regarding waivers:
          </Typography>
          <Typography variant='body1'>
            Each individual attending must complete their own waiver.
            If you are registering multiple people, please ensure each person is present to complete their waiver.
          </Typography>
        </Alert>
      )}
    </>
  );
};
